import '../custom.scss';
import { Outlet } from "react-router-dom";
import Navbar from "../Navbar";

const Layout = () => {
  return (
    <div className="row App shell">
      <div className="col-1 navbar">
        <Navbar />
      </div>
      <div className="col-11 content-space">
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;